import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { BackToTop } from '../svgs/BackToTop'

// Styled Components
export const BackToTopContainer = styled.div`
	bottom: ${({ hitFooter }) => (hitFooter ? 0 : '20px')};
	padding-top: 10px;
	position: ${({ hitFooter }) => (hitFooter ? 'absolute' : 'fixed')};

	svg,
	path,
	text {
		cursor: pointer;
		transition: all 0.3s ease;
	}

	:hover {
		path,
		text {
			fill: ${({ theme }) => theme.backToTop.hoverColor};
		}
	}
`

BackToTopSticky.propTypes = {
	hitFooter: PropTypes.bool,
	isSticky: PropTypes.bool,
}

export function BackToTopSticky(props) {
	const { isSticky, hitFooter, className } = props

	return (
		<BackToTopContainer isSticky={isSticky} hitFooter={hitFooter} className={className}>
			<BackToTop />
		</BackToTopContainer>
	)
}
